var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"protocol-frame"},[_c('h1',[_vm._v("Twiage's AI Enhanced Protocol")]),_c(_setup.Protocol,{attrs:{"twiage-case":null}},[_c('div',[_c('button',{staticClass:"btn btn-outline-dark"},[_vm._v("Ask Question")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }